// 全螢幕看圖：任何地方呼叫 openImage(網址) 就會開啟，不離開 App（PWA 內不會跳到瀏覽器）
// 手機可雙指縮放與拖曳（瀏覽器原生捲動／縮放），點背景或 ✕ 關閉
import React, { useEffect, useState } from 'react';
import { createPortal } from 'react-dom';

const EVENT = 'gsat-image';
export const openImage = (url: string) => window.dispatchEvent(new CustomEvent<string>(EVENT, { detail: url }));

export default function ImageViewer() {
  const [url, setUrl] = useState<string | null>(null);
  useEffect(() => {
    const h = (e: Event) => setUrl((e as CustomEvent<string>).detail);
    const onKey = (e: KeyboardEvent) => { if (e.key === 'Escape') setUrl(null); };
    window.addEventListener(EVENT, h);
    window.addEventListener('keydown', onKey);
    return () => { window.removeEventListener(EVENT, h); window.removeEventListener('keydown', onKey); };
  }, []);
  if (!url) return null;
  return createPortal(
    <div role="dialog" aria-label="圖片" onClick={() => setUrl(null)}
      style={{ position: 'fixed', inset: 0, zIndex: 9999, background: 'rgba(0,0,0,.92)', overflow: 'auto', touchAction: 'pan-x pan-y pinch-zoom',
        display: 'flex', alignItems: 'center', justifyContent: 'center', padding: 'env(safe-area-inset-top, 0px) 0 env(safe-area-inset-bottom, 0px)' }}>
      <button aria-label="關閉" onClick={e => { e.stopPropagation(); setUrl(null); }}
        style={{ position: 'fixed', top: 'calc(10px + env(safe-area-inset-top, 0px))', right: 12, width: 40, height: 40, borderRadius: 99, border: 'none',
          background: 'rgba(255,255,255,.2)', color: '#fff', fontSize: 20, cursor: 'pointer', zIndex: 1 }}>✕</button>
      <img src={url} alt="" style={{ maxWidth: '100%', maxHeight: '100%', objectFit: 'contain', background: '#fff' }} />
    </div>, document.body);
}
